import { cardNetworkValidator } from "cc-tools/card-network-validator";

import { CreditCardNetwork } from "chameleon/lib/components/display-cards/display-cards";

export const cardNetwork =
  ({
    allowedCardNetworks = [],
  }: {
    allowedCardNetworks?: CreditCardNetwork[];
  }) =>
  (value: string): boolean => {
    const { isAllowedCardNetwork } = cardNetworkValidator(
      value,
      allowedCardNetworks
    );
    return isAllowedCardNetwork;
  };
